export enum InvestigationReportProcedureCode {
	None = "NO_PROCEDURES",
	ActionCreated = "ACTION_CREATED",
	Notified = "NOTIFIED",
	NotNotified = "NOT_NOTIFIED",
	InvitationSent = "INVITATION_SENT",
	Answered = "ANSWERED",
	AwaitingAnswer = "AWAITING_ANSWER",
	NoAnswerAwaitingDecision = "NO_ANSWER_AWAITING_DECISION",
	NonResponseDecided = "NON_RESPONSE_DECIDED",
	Attended = "ATTENDED",
	Absent = "ABSENT",
	AwaitingSession = "AWAITING_SESSION",
	NotHeld = "NOT_HELD",
	MinutesAttested = "MINUTES_ATTESTED",
	MinutesAwaitingAttestation = "MINUTES_AWAITING_ATTESTATION",
	MinutesNotApproved = "MINUTES_NOT_APPROVED",
	SignedMinutesUploaded = "SIGNED_MINUTES_UPLOADED",
	SignedMinutesMissing = "SIGNED_MINUTES_MISSING",
	SupplementaryFulfilled = "SUPPLEMENTARY_FULFILLED",
	SupplementaryOpen = "SUPPLEMENTARY_OPEN",
}
